import type { InvitePreviewResponse, OrganizationResponse } from '@nargus/shared';
import { request } from '../http';

export const inviteResource = {
  preview: (token: string): Promise<InvitePreviewResponse> => request(`/invites/${token}`),

  accept: (token: string): Promise<OrganizationResponse> =>
    request(`/invites/${token}/accept`, { method: 'POST' }),
};
